import { createEntityAdapter } from '@reduxjs/toolkit';

import type { CSDashboardSummary } from '~/common/models/csDashboard.model';

//adapters for dashboard summary
export const csDashboardAdapter = createEntityAdapter<CSDashboardSummary>({});
